import { readNavigationItem, writeNavigationItem } from './navigationMemory';

const DRAFT_KEY = 'firstResultDraft';
export const FIRST_RESULT_GOAL_MAX_LENGTH = 4000;

export function readFirstResultDraft(storage) {
  try {
    const draft = JSON.parse(readNavigationItem(storage, DRAFT_KEY) || '{}');
    return {
      goal: typeof draft.goal === 'string' ? draft.goal.slice(0, FIRST_RESULT_GOAL_MAX_LENGTH) : '',
      hasSavedGoal: typeof draft.goal === 'string',
      caseId: /^[1-9]\d*$/.test(String(draft.caseId || '')) ? String(draft.caseId) : null,
      files: Array.isArray(draft.files) ? draft.files.slice(0, 100).filter(file => typeof file?.name === 'string').map(file => ({ name: file.name, size: null })) : [],
    };
  } catch {
    return { goal: '', hasSavedGoal: false, caseId: null, files: [] };
  }
}

export function saveFirstResultDraft(storage, draft) {
  writeNavigationItem(storage, DRAFT_KEY, JSON.stringify(draft));
}

export function clearFirstResultDraft(storage) {
  writeNavigationItem(storage, DRAFT_KEY, '');
}
